// eslint-disable-next-line import/prefer-default-export
export const NOTIFICATION_COLLECTION = 'notifications';
